import lzString from 'lz-string';
export const safeCompress = (oriString) => {
    try {
        return lzString.compressToEncodedURIComponent(oriString);
    }
    catch (err) {
        return oriString;
    }
};
export const safeDecompress = (compressedString, fallback) => {
    try {
        const decompressed = lzString.decompressFromEncodedURIComponent(compressedString);
        return decompressed === null ? fallback : decompressed;
    }
    catch (err) {
        return fallback;
    }
};
//# sourceMappingURL=compress.js.map